// features/client/client.validation.js

export const validation = {
  trade_name: (value) => {
    if (!value?.trim()) return "Trade name is required";
    return "";
  },
  // is_activated: (value) => {
  //   if (!value) return "Status is required";
  //   return "";
  // },

};